import { Paper, Stack, Typography } from "@mui/material";
import { PageHeading } from "@aeriosiq/ui";
import { WrenchIcon } from "@aeriosiq/ui/icons";
interface Props {
  title: string;
  description?: string;
}

/**
 * Generic landing for nav entries that exist in the sidebar (matching the
 * reference layout) but whose features haven't been built yet. Beats a 404
 * for discoverability and keeps the IA visible to users without lying about
 * what works.
 */
export function ComingSoonPage({ title, description }: Props) {
  return (
    <Stack spacing={2}>
      <PageHeading>{title}</PageHeading>
      <Paper
        variant="outlined"
        role="region"
        aria-label={`${title} — coming soon`}
        sx={{
          p: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          textAlign: "center",
        }}
      >
        <WrenchIcon
          sx={{ fontSize: 48, color: "text.secondary" }}
          aria-hidden
        />
        <Typography variant="h6" component="p">
          Coming soon
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 480 }}
        >
          {description ??
            "This area is part of the planned AeriosIQ IA but isn’t implemented yet. The Inspections workflow is the focus of MVP — see the sidebar."}
        </Typography>
      </Paper>
    </Stack>
  );
}
